/*
 * @Description: 营销活动交易成功
 * @Author: kayvor
 * @Date: 2020-08-20 11:18:02
 * @LastEditors: kayvor
 * @LastEditTime: 2020-08-20 11:22:52
 */

import ajax from '../http/ajax'

/**
 * 获取保养建议页列表
 * @param {*} params 参数
 */
export const getPaySuccessResult = params => {
    return ajax.get('paySuccess', params)
}
